import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    candidateMessageReply: {},
    lastOpenedNotification: null,
    vacancyWithUnreadMessage: null,
    refreshNotificationsTrigger: 0
}

const slice = createSlice({
    name: 'notificationsMessages',
    initialState,
    reducers: {
        setCandidateMessageReply: (state, { payload }) => {
            state.candidateMessageReply = payload;
        },
        markMessageAsRead: (state, { payload }) => {
            const { candidateId } = payload;
            if (state.candidateMessageReply[candidateId]) {
                state.candidateMessageReply[candidateId].hasUnreadMessage = false;
            }
        },
        setVacancyWithUnreadMessage: (state, { payload }) => {
            return {
                ...state,
                vacancyWithUnreadMessage: payload
            };
        },
        triggerNotificationRefresh: (state) => {
            state.refreshNotificationsTrigger += 1;
        }
    }
})

const { reducer, actions } = slice

export const { 
    setCandidateMessageReply, markMessageAsRead, setVacancyWithUnreadMessage, triggerNotificationRefresh
  } = actions
  
export default reducer
